import React from 'react'

function RefundPolicy() {
    return (
        <div>

            <li>
                Once registration is completed, the following applies regarding Refunds and Withdrawals.

                <ol>
                    <li>$50 for books is non-refundable.</li>
                    <li>
                        If withdrawing within 2 weeks of commencement of school, $150 is
                        refundable after deduction of book money.
                    </li>
                    <li>
                        If withdrawing after 2 weeks but during the first term, 70% of fees
                        paid will be refunded after deduction of book money.
                    </li>
                    <li>
                        If withdrawing during the second term, 30% of fees paid will be
                        refunded after deduction of book money.
                    </li>
                    <li>
                        If withdrawing after the end of second term, there will be <b>NO refund</b>.
                    </li>
                </ol>
            </li>
        </div>
    )
}

export default RefundPolicy